import Rest from '@/services/Rest';

/**
 * @typedef {OfferService}
 */
export default class OfferService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/offers'
}
